var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from "class-transformer";
import { IsArray, IsBoolean, IsDate, IsEnum, IsOptional, IsString, ValidateNested } from "class-validator";
export var DataSourceType;
(function (DataSourceType) {
    DataSourceType["DATAWAREHOUSE_BIGQUERY"] = "DATAWAREHOUSE_BIGQUERY";
    DataSourceType["DATAWAREHOUSE_SNOWFLAKE"] = "DATAWAREHOUSE_SNOWFLAKE";
})(DataSourceType || (DataSourceType = {}));
export const DATA_SOURCE_TYPE_DISPLAY_MAP = {
    [DataSourceType.DATAWAREHOUSE_BIGQUERY]: "BigQuery",
    [DataSourceType.DATAWAREHOUSE_SNOWFLAKE]: "Snowflake",
};
export var DataClassificationStatus;
(function (DataClassificationStatus) {
    DataClassificationStatus["IN_PROGRESS"] = "IN_PROGRESS";
    DataClassificationStatus["COMPLETED"] = "COMPLETED";
})(DataClassificationStatus || (DataClassificationStatus = {}));
export var DataSourceHealthStatus;
(function (DataSourceHealthStatus) {
    DataSourceHealthStatus["UNKNOWN"] = "UNKNOWN";
    DataSourceHealthStatus["HEALTHY"] = "HEALTHY";
    DataSourceHealthStatus["SERVICE_DISRUPTION"] = "SERVICE_DISRUPTION";
    DataSourceHealthStatus["PARTIAL_SERVICE_DISRUPTION"] = "PARTIAL_SERVICE_DISRUPTION";
    DataSourceHealthStatus["OPERATIONAL"] = "OPERATIONAL";
})(DataSourceHealthStatus || (DataSourceHealthStatus = {}));
export class DataWarehouseClassificationInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], DataWarehouseClassificationInput.prototype, "id", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DataWarehouseClassificationInput.prototype, "dataSourceId", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], DataWarehouseClassificationInput.prototype, "enabled", void 0);
__decorate([
    IsEnum(DataClassificationStatus),
    __metadata("design:type", String)
], DataWarehouseClassificationInput.prototype, "status", void 0);
export class DataWarehouseConnectorInput {
}
__decorate([
    IsEnum(DataSourceType),
    __metadata("design:type", String)
], DataWarehouseConnectorInput.prototype, "type", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], DataWarehouseConnectorInput.prototype, "authConfig", void 0);
export class DataWarehouseConnectorDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(DataSourceType),
    __metadata("design:type", String)
], DataWarehouseConnectorDto.prototype, "type", void 0);
export class DataWarehouseDataSourceInput {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], DataWarehouseDataSourceInput.prototype, "id", void 0);
__decorate([
    IsEnum(DataSourceType),
    __metadata("design:type", String)
], DataWarehouseDataSourceInput.prototype, "type", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DataWarehouseDataSourceInput.prototype, "patientIdFieldName", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DataWarehouseDataSourceInput.prototype, "schema", void 0);
export class DataSourceMetadata {
}
export class BigQueryDataSourceMetadata extends DataSourceMetadata {
    constructor(fields) {
        super();
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], BigQueryDataSourceMetadata.prototype, "datasetId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], BigQueryDataSourceMetadata.prototype, "projectId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], BigQueryDataSourceMetadata.prototype, "description", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], BigQueryDataSourceMetadata.prototype, "location", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], BigQueryDataSourceMetadata.prototype, "creationTime", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], BigQueryDataSourceMetadata.prototype, "lastModifiedTime", void 0);
export class DataSourceInput {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], DataSourceInput.prototype, "id", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DataSourceInput.prototype, "name", void 0);
__decorate([
    IsEnum(DataSourceType),
    __metadata("design:type", String)
], DataSourceInput.prototype, "type", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DataSourceInput.prototype, "authConfig", void 0);
__decorate([
    Type(() => BigQueryDataSourceMetadata),
    IsOptional(),
    __metadata("design:type", BigQueryDataSourceMetadata)
], DataSourceInput.prototype, "metadata", void 0);
export class DataSourceSearchInput {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], DataSourceSearchInput.prototype, "name", void 0);
export class DataSourceTablesInput {
}
__decorate([
    IsArray(),
    __metadata("design:type", Array)
], DataSourceTablesInput.prototype, "tableNames", void 0);
export class DataSourceDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], DataSourceDto.prototype, "id", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DataSourceDto.prototype, "name", void 0);
__decorate([
    IsEnum(DataSourceType),
    __metadata("design:type", String)
], DataSourceDto.prototype, "type", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DataSourceDto.prototype, "authConfig", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], DataSourceDto.prototype, "createdAt", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], DataSourceDto.prototype, "updatedAt", void 0);
__decorate([
    Type(() => BigQueryDataSourceMetadata),
    IsOptional(),
    __metadata("design:type", BigQueryDataSourceMetadata)
], DataSourceDto.prototype, "metadata", void 0);
__decorate([
    IsEnum(DataSourceHealthStatus),
    __metadata("design:type", String)
], DataSourceDto.prototype, "healthStatus", void 0);
export class DataSourceDtoWithInProgressClassification extends DataSourceDto {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsArray(),
    __metadata("design:type", Array)
], DataSourceDtoWithInProgressClassification.prototype, "inProgressClassificationRunIds", void 0);
export class DataWarehouseAddedEntityDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], DataWarehouseAddedEntityDto.prototype, "dataSourceId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DataWarehouseAddedEntityDto.prototype, "studyId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], DataWarehouseAddedEntityDto.prototype, "studyTitle", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DataWarehouseAddedEntityDto.prototype, "dataWarehouseClassificationEntityId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DataWarehouseAddedEntityDto.prototype, "name", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DataWarehouseAddedEntityDto.prototype, "addedName", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DataWarehouseAddedEntityDto.prototype, "policy", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DataWarehouseAddedEntityDto.prototype, "metadata", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], DataWarehouseAddedEntityDto.prototype, "isAdded", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], DataWarehouseAddedEntityDto.prototype, "errorMessage", void 0);
export class DataWarehouseUserDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], DataWarehouseUserDto.prototype, "dataSourceId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DataWarehouseUserDto.prototype, "studyId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DataWarehouseUserDto.prototype, "userId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DataWarehouseUserDto.prototype, "email", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], DataWarehouseUserDto.prototype, "isAdded", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], DataWarehouseUserDto.prototype, "errorMessage", void 0);
export class DatasetDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], DatasetDto.prototype, "datasetId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], DatasetDto.prototype, "projectId", void 0);
export class TableColumnDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], TableColumnDto.prototype, "id", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], TableColumnDto.prototype, "name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], TableColumnDto.prototype, "description", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], TableColumnDto.prototype, "dataType", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], TableColumnDto.prototype, "mode", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], TableColumnDto.prototype, "createdAt", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], TableColumnDto.prototype, "updatedAt", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], TableColumnDto.prototype, "dataWarehouseEntityId", void 0);
export class TableDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], TableDto.prototype, "id", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], TableDto.prototype, "dataSourceId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], TableDto.prototype, "name", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], TableDto.prototype, "registered", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], TableDto.prototype, "createdAt", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    __metadata("design:type", Date)
], TableDto.prototype, "updatedAt", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], TableDto.prototype, "metadata", void 0);
__decorate([
    Type(() => TableColumnDto),
    ValidateNested({ each: true }),
    IsArray(),
    __metadata("design:type", Array)
], TableDto.prototype, "columns", void 0);
export var DataWarehouseAuthStatus;
(function (DataWarehouseAuthStatus) {
    DataWarehouseAuthStatus["NOTHING"] = "NOTHING";
    DataWarehouseAuthStatus["INITING"] = "INITING";
    DataWarehouseAuthStatus["NO_DB_RECORD"] = "NO_DB_RECORD";
    DataWarehouseAuthStatus["NO_CONFIG"] = "NO_CONFIG";
    DataWarehouseAuthStatus["INCORRECT_CONFIG"] = "INCORRECT_CONFIG";
    DataWarehouseAuthStatus["CONFIG_FAILED"] = "CONFIG_FAILED";
    DataWarehouseAuthStatus["RUNNING"] = "RUNNING";
    DataWarehouseAuthStatus["EXCEPTION"] = "EXCEPTION";
})(DataWarehouseAuthStatus || (DataWarehouseAuthStatus = {}));
